export default __webpack_public_path__ + "static/Donald.Mitchell_1_social-0ac2fe9898c857bced7307848a33306a.jpg";